const getProvinceLabel = (country) => {
  return country == 'AR' ? 'Provincia' : 'Departamento'
}

export default getProvinceLabel